/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */
// Needed for promises es6 generator support
import '@babel/polyfill';

// Styles
import './styles/master-styles.scss';

import App from 'components/App';
import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { finalStore } from 'store';
import { BrowserRouter } from 'react-router-dom';
// import Bugsnag from '@bugsnag/js';
// import BugsnagPluginReact from '@bugsnag/plugin-react';
import multiAnalytics from './services/multi-analytics';

const data = window.__PRELOADED_STATE__;
delete window.__PRELOADED_STATE__;
// let bugsnagReleaseStages = process.env.BUGSNAG_NOTIFY_RELEASE_STAGES;
//
// if (bugsnagReleaseStages) bugsnagReleaseStages = bugsnagReleaseStages.split(',');
//
// Bugsnag.start({
//     apiKey: process.env.BUGSNAG_API_KEY_REACT,
//     releaseStage: process.env.BUGSNAG_RELEASE_STAGE,
//     notifyReleaseStages: bugsnagReleaseStages,
//     plugins: [new BugsnagPluginReact()],
// });
//
// const ErrorBoundary = Bugsnag.getPlugin('react')
//     .createErrorBoundary(React);

// REMOVE THIS WHEN YOU REACTIVATE BUGSNAG AND UNCOMMENT THE ABOVE
const ErrorBoundary = ({ children }) => <>{children}</>;


const userId = document.querySelector('meta[name="_uid"]').content;

hydrateRoot(
    document.getElementById('react-app'),
    <ErrorBoundary>
        <Provider store={finalStore(data)}>
            <BrowserRouter>
                <App isNotFound={data.isNotFound} />
            </BrowserRouter>
        </Provider>
    </ErrorBoundary>,
);


multiAnalytics.init({
    user_id: userId,
});
